export const ABOUT_US_METRICS = [
    { number: 40, plus: "+", desc: "Developers" },
    { number: 10, plus: "+", desc: "Current clients" },
    { number: 30, plus: "+", desc: "Lifetime clients" },
    { number: 5, plus: "+", desc: "Years in the market"},
    { number: 60, plus: "%", desc: "Long-standing developers"},
    { number: 2, plus: "+", desc: "Years of the average parthership"},
]
